type SettingsSubtitleProps = {
  subtitle: string
}

const SettingsSubtitle = ({ subtitle }: SettingsSubtitleProps) => {
  return <p className="text-[18px] font-medium leading-[1.6] text-muted">{subtitle}</p>
}

export default SettingsSubtitle
